import React, { useEffect, useState } from "react"
import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow,
} from "@react-google-maps/api"
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle } from "reactstrap"
import { setBreadcrumbItems } from "store/actions"
import { connect } from "react-redux"

interface LatLng {
  lat: number;
  lng: number;
}

interface BreadcrumbItem {
  title: string;
  link: string;
}

interface MapsGoogleProps {
  setBreadcrumbItems: (title: string, items: BreadcrumbItem[]) => void;
}

const containerStyle = {
  width: "100%",
  height: "300px",
}

const center: LatLng = {
  lat: 37.778519,
  lng: -122.40564,
}

const second: LatLng = {
  lat: 54.526,
  lng: 15.2551,
}

const third: LatLng = {
  lat: 8.7832,
  lng: 34.5085,
}

const forth: LatLng = {
  lat: 19.076,
  lng: 72.8777,
}

const MapsGoogle = (props: MapsGoogleProps) => {
  document.title = "Maps Google | Lexa - Responsive Bootstrap 5 Admin Dashboard"

  const breadcrumbItems = [
    { title: "Lexa", link: "#" },
    { title: "Maps", link: "#" },
    { title: "Google Maps", link: "#" },
  ]

  useEffect(() => {
    props.setBreadcrumbItems("Google Maps", breadcrumbItems)
  })

  const selectedPlace = { name: "" }

  const [selected, setSelected] = useState<LatLng | null>(null)

  const onSelect = (marker: LatLng) => {
    setSelected(marker)
  }

  return (
    <React.Fragment>
      <Row>
        <Col lg={6}>
          <Card>
            <CardBody>
              <CardTitle>Markers</CardTitle>
              <CardSubtitle className="mb-3">
                Example of google maps.
              </CardSubtitle>
              <div
                id="gmaps-markers"
                className="gmaps"
                style={{ position: "relative" }}
              >
                <LoadScript googleMapsApiKey="AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE">
                  <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={center}
                    zoom={14}
                  >
                    <Marker
                      position={center}
                      onClick={() => onSelect(center)}
                    />
                    {selected && (
                      <InfoWindow
                        position={selected}
                        onCloseClick={() => setSelected(null)}
                      >
                        <div>
                          <h1>{selectedPlace.name}</h1>
                        </div>
                      </InfoWindow>
                    )}
                  </GoogleMap>
                </LoadScript>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col lg={6}>
          <Card>
            <CardBody>
              <CardTitle>Overlays</CardTitle>
              <CardSubtitle className="mb-3">
                Example of google maps.
              </CardSubtitle>
              <div
                id="gmaps-overlay"
                className="gmaps"
                style={{ position: "relative" }}
              >
                <LoadScript googleMapsApiKey="AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE">
                  <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={second}
                    zoom={14}
                  >
                    <Marker
                      position={second}
                      onClick={() => onSelect(second)}
                    />
                    {selected && (
                      <InfoWindow
                        position={selected}
                        onCloseClick={() => setSelected(null)}
                      >
                        <div>
                          <h1>{selectedPlace.name}</h1>
                        </div>
                      </InfoWindow>
                    )}
                  </GoogleMap>
                </LoadScript>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col lg={6}>
          <Card>
            <CardBody>
              <CardTitle>Street View Panoramas</CardTitle>
              <CardSubtitle className="mb-3">
                Example of google maps.
              </CardSubtitle>
              <div
                id="gmaps-markers"
                className="gmaps"
                style={{ position: "relative" }}
              >
                <LoadScript googleMapsApiKey="AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE">
                  <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={third}
                    zoom={14}
                  >
                    <Marker position={third} onClick={() => onSelect(third)} />
                    {selected && (
                      <InfoWindow
                        position={selected}
                        onCloseClick={() => setSelected(null)}
                      >
                        <div>
                          <h1>{selectedPlace.name}</h1>
                        </div>
                      </InfoWindow>
                    )}
                  </GoogleMap>
                </LoadScript>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col lg={6}>
          <Card>
            <CardBody>
              <CardTitle>Map Types</CardTitle>
              <CardSubtitle className="mb-3">
                Example of google maps.
              </CardSubtitle>
              <div
                id="gmaps-overlay"
                className="gmaps"
                style={{ position: "relative" }}
              >
                <LoadScript googleMapsApiKey="AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE">
                  <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={forth}
                    zoom={14}
                  >
                    <Marker position={forth} onClick={() => onSelect(forth)} />
                    {selected && (
                      <InfoWindow
                        position={selected}
                        onCloseClick={() => setSelected(null)}
                      >
                        <div>
                          <h1>{selectedPlace.name}</h1>
                        </div>
                      </InfoWindow>
                    )}
                  </GoogleMap>
                </LoadScript>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(MapsGoogle);